"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = isNeededImg;

require("core-js/modules/es.regexp.exec.js");

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

/**
 * @file 是否为业务图片
 * @author zhangyanting
 */

/**
 * 元素是否为影响首屏需要被统计的图片
 * @param {string} src 元素地址
 * @private
 */
function isNeededImg(_ref) {
  var domContainer = _ref.domContainer,
      src = _ref.src;

  if (!src || !domContainer) {
    return false;
  }

  var imgNoFilter = [/^data:image\//, // base64
  /^http(s){0,1}:\/\/hm.baidu.com\/hm.gif/, // 百度统计
  /^http(s){0,1}:\/\/sestat.baidu.com\/mwb2.gif/, // spy统计
  /^http(s){0,1}:\/\/thunderlog.baidu.com/, // thunder线下统计
  /^http(s){0,1}:\/\/hpd.baidu.com\/v.gif/, // thunder线上统计
  /^http(s){0,1}:\/\/mbd.baidu.com\/ztbox/ // ubc统计
  ]; // 不需要纳入性能统计的域名

  var isNoNeededImg = (0, _some.default)(imgNoFilter).call(imgNoFilter, function (filter) {
    return filter.test(src);
  });

  if (isNoNeededImg) {
    return false;
  } // 不作为首屏统计的图片地址


  if (!!domContainer.getAttribute('data-nolog')) {
    return false;
  }

  return true;
}